const presidentialManagement = {
  en: {
    presidentialManagementPage: {
      statuses: { approved: "approved", pending: "pending", rejected: "rejected", certified: "certified" },
      title: "Presidential Election Management",
      subtitle: "National • Single Round • First Past the Post",
      shareTitle: "EReMS Cameroon - Presidential Election Results",
      shareText: "🗳️ Presidential Election: {{count}} stations reporting!",
      refresh: "Refresh",
      unknown: "Unknown",
      national: "National",
      stats: {
        stationsReported: "Stations Reported",
        totalVotes: "Total Votes",
        validVotes: "Valid Votes",
        rejectedVotes: "Rejected Votes"
      },
      projectedWinner: "Projected Winner",
      votesCount: "{{count}} votes",
      tabs: {
        overview: "Overview",
        candidates: "Candidates ({{count}})",
        results: "Results ({{count}})"
      },
      overview: {
        candidateResults: "Candidate Results",
        noResultsData: "No results data available",
        voteDistribution: "Vote Distribution",
        noData: "No data available"
      },
      candidatesTab: { none: "No candidates registered" },
      resultsTab: {
        submitted: "{{division}} • Submitted {{date}}",
        validCount: "{{count}} valid",
        none: "No results submitted"
      }
    }
  },
  fr: {
    presidentialManagementPage: {
      statuses: { approved: "approuvé", pending: "en attente", rejected: "rejeté", certified: "certifié" },
      title: "Gestion de l'élection présidentielle",
      subtitle: "National • Tour unique • Scrutin majoritaire à un tour",
      shareTitle: "EReMS Cameroon - Résultats de l'élection présidentielle",
      shareText: "🗳️ Élection présidentielle : {{count}} bureaux de vote ont transmis leurs résultats !",
      refresh: "Actualiser",
      unknown: "Inconnu",
      national: "National",
      stats: {
        stationsReported: "Bureaux ayant transmis",
        totalVotes: "Total des votes",
        validVotes: "Votes valides",
        rejectedVotes: "Votes rejetés"
      },
      projectedWinner: "Vainqueur projeté",
      votesCount: "{{count}} voix",
      tabs: {
        overview: "Aperçu",
        candidates: "Candidats ({{count}})",
        results: "Résultats ({{count}})"
      },
      overview: {
        candidateResults: "Résultats des candidats",
        noResultsData: "Aucune donnée de résultats disponible",
        voteDistribution: "Répartition des voix",
        noData: "Aucune donnée disponible"
      },
      candidatesTab: { none: "Aucun candidat enregistré" },
      resultsTab: {
        submitted: "{{division}} • Soumis le {{date}}",
        validCount: "{{count}} valides",
        none: "Aucun résultat soumis"
      }
    }
  }
};

export default presidentialManagement;
